import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

// Libs
import * as Sentry from '@sentry/vue'
import { Integrations as TracingIntegrations } from '@sentry/tracing'
import { ReportingObserver as ReportingObserverIntegration } from '@sentry/integrations'
import { Offline as OfflineIntegration } from '@sentry/integrations'

import vuetify from './plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import Vuelidate from 'vuelidate'
import i18n from './i18n'

// Utils
import './utils/apiHelpers'
import './utils/globalFilters'
import { sentryConfigureScope } from './utils/errorHandler'

// Styles
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import './styles/main.scss'

Vue.config.errorHandler = (err, vm, info) => {
    if (process.env.NODE_ENV !== 'production') {
        Vue.util.warn(`Error in ${info}: "${err.toString()}"`, vm)
    }

    console.error(err)
}

if (process.env.VUE_APP_ENV !== 'local') {
    Sentry.init({
        Vue: Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_ENV,
        release: process.env.VUE_APP_VERSION,
        integrations: [
            new TracingIntegrations.BrowserTracing(),
            new OfflineIntegration(),
            new ReportingObserverIntegration(
                {
                    types: ['crash', 'intervention']
                }
            ),
        ],
        tracesSampleRate: 0.2,
        beforeBreadcrumb(breadcrumb, hint) {
            if (breadcrumb.category === 'ui.click') {
                const searchDepth = 4,
                    { target } = hint.event

                let parentElement = null

                if (target) {
                    if (target.dataset.sentryLabel) {
                        breadcrumb.message = target.dataset.sentryLabel
                    } else {
                        parentElement = target.parentElement

                        for (let i = 0; i < searchDepth; i++) {
                            if (parentElement.dataset.sentryLabel) {
                                breadcrumb.message = parentElement.dataset.sentryLabel

                                break
                            } else {
                                parentElement = parentElement.parentElement
                            }
                        }
                    }
                } else {
                    breadcrumb = null
                }
            }

            return breadcrumb
        },
        attachStacktrace: true
    })

    sentryConfigureScope()
}

Vue.use(Vuelidate)
Vue.use(DatetimePicker)

Vue.config.productionTip = false


new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')